import Axios from "axios";
import React, { useEffect, useState } from "react";
import "react-bulma-components/dist/react-bulma-components.min.css";
import { clarity } from "react-microsoft-clarity";
import { BrowserRouter, Redirect, Route, Switch, useLocation } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import packageJson from "../package.json";
import ConsolidatedMIS from "./Components/Admin/Analytics/ConsolidatedMIS";
import PartnerCommunicationAnalytics from "./Components/Admin/Analytics/PartnerCommunicationAnalytics";
import ReconAnalytics from "./Components/Admin/Analytics/ReconAnalytics";
import TaskManagementAnalytics from "./Components/Admin/Analytics/TaskManagementAnalytics";
import CBUpdate from "./Components/Admin/CBUpdate";
import ConfigTemplates from "./Components/Admin/ConfigTemplates";
import LedgerData from "./Components/Admin/LedgerData";
import PaymentDetails from "./Components/Admin/PaymentDetails";
import PreprocessingScripts from "./Components/Admin/PreprocessingScripts";
import Register from "./Components/Admin/Register";
import SapData from "./Components/Admin/SapData";
import TallyLedger from "./Components/Admin/TallyLedger";
import TallyVoucher from "./Components/Admin/TallyVoucher";
import UnpaidInvoice from "./Components/Admin/UnpaidInvoice";
import Userlist from "./Components/Admin/Userlist";
import "./Components/Common/Common.scss";
import SideBar from "./Components/Common/SideBar";
import { userContext } from "./Components/Contexts/userContext";
import CustomToast from "./Components/CustomToast";
import Login from "./Components/Login/Login";
import ClosureTracker from "./Components/Recon360/DisputeResolution/ClosureTracker/ClosureTracker";
import DisputedEntries from "./Components/Recon360/DisputeResolution/DisputedEntries/DisputedEntries";
import DrUserSettings, {
  canManageDrUserSettings,
} from "./Components/Recon360/DisputeResolution/DrUserSettings/DrUserSettings";
import RejectedInvoices from "./Components/Recon360/DisputeResolution/RejectedInvoices/RejectedInvoices";
import VendorHold from "./Components/Recon360/DisputeResolution/VendorHold/VendorHold";
import Faq from "./Components/Recon360/Faq/Faq";
import LedgerPreprocessingPortal from "./Components/Recon360/LedgerPreprocessingPortal/LedgerPreprocessingPortal";
import LedgerDownload from "./Components/Recon360/LedgerTools/LedgerDownload";
import LedgerUpload from "./Components/Recon360/LedgerTools/LedgerUpload";
import VendorPaymentAutomation from "./Components/Recon360/LedgerTools/VendorPaymentAutomation";
import AuditCommunication from "./Components/Recon360/PartnerCommunication/AuditCommunication/AuditCommunication";
import BalanceConfirmationPortalContext from "./Components/Recon360/PartnerCommunication/BalanceConfirmationPortal/BalanceConfirmationPortalContext";
import CommonReport from "./Components/Recon360/PartnerCommunication/Common/CommonReport";
import PartnerCommunicationContext from "./Components/Recon360/PartnerCommunication/Context/PartnerCommunicationContext";
import MsmeConfirmation from "./Components/Recon360/PartnerCommunication/MsmeConfirmation/MsmeConfirmation";
import PartnerPortal from "./Components/Recon360/PartnerCommunication/MsmePartnerPortal";
import PartnerPortalWrapper from "./Components/Recon360/PartnerCommunication/PartnerPortal/PartnerPortalWrapper";
import PartnerMaster from "./Components/Recon360/PartnerMaster/PartnerMaster";
import AnnotationPage from "./Components/Recon360/PDFAnnotate";
import Recon360 from "./Components/Recon360/Recon360";
import MailMISReports from "./Components/Recon360/ReconMIS/MailMISReports/MailMISReports";
import PartnerRiskManagement from "./Components/Recon360/ReconMIS/PartnerRiskManagement/PartnerRiskManagement";
import ReconSettings from "./Components/Recon360/ReconSettings/ReconSettings";
import SupplierChainDashboard from "./Components/Recon360/SupplierChainDashboard/SupplierChainDashboard";
import TaskTracker from "./Components/Recon360/TaskTracker/TaskTracker";
import VpDisputedEntries from "./Components/Recon360/VendorPortal/DisputedEntries/VpDisputedEntries";
import EarlyPaymentVendorPortal from "./Components/Recon360/VendorPortal/EarlyPaymentVendorPortal";
import FaqVendorPortal from "./Components/Recon360/VendorPortal/FaqVendorPortal/FaqVendorPortal";
import HoldResolutionVendorPortal from "./Components/Recon360/VendorPortal/HoldResolutionVendorPortal";
import LedgerSummaryVendorPortal from "./Components/Recon360/VendorPortal/LedgerSummaryVendorPortal";
import ReconciliationVendorPortal from "./Components/Recon360/VendorPortal/ReconciliationVendorPortal";
import RejectedInvoicesVendorPortal from "./Components/Recon360/VendorPortal/RejectedInvoicesVendorPortal";
import VendorPortalLayout from "./Components/Recon360/VendorPortal/VendorPortalLayout";
import ChangePassword from "./Components/ResetPassword/ChangePassword";
import ResetPassword from "./Components/ResetPassword/ResetPassword";
import { FrontendActor, UserRole } from "./entity/models/FrontendActor";
import { UseCaseType } from "./entity/recon-entity/ReconInterfaces";
import { trackMixpanelPageView } from "./Utils/Mixpanel/mixpanel";
import { RECON360_SUB_TAB } from "./Utils/Recon/Recon360/Constants";

/** Tracks page views in Mixpanel whenever the route changes */
const MixpanelPageTracker = () => {
  const location = useLocation();
  useEffect(() => {
    trackMixpanelPageView(location.pathname);
  }, [location.pathname]);
  return null;
};

const NON_APP_PATHS = [
  { path: "/", exact: true },
  { path: "/reset", exact: false },
  { path: "/annotate", exact: true },
  { path: "/partnerPortal", exact: false },
  { path: "/balanceConfirmationPortal", exact: false },
  { path: "/balanceConfirmReport", exact: false },
  { path: "/ledgerRequestReport", exact: false },
  { path: "/preprocessing", exact: false },
  { path: "/vendorPortal", exact: false },
  { path: "/vendorPortalEmbed", exact: false },
];

export const isShownSideBar = (path: string) => {
  let isNonAppPath = false;
  NON_APP_PATHS.forEach((p) => {
    if (p.exact) {
      if (path === p.path) isNonAppPath = true;
    } else if (!p.exact) {
      if (path.includes(p.path)) isNonAppPath = true;
    }
  });
  // if non App path don't show side bar
  return isNonAppPath ? false : true;
};

export const handleUnauthenticatedUser = (error) => {
  // Check if the error is a 401 status
  if (error.response?.status === 401) {
    // Don't redirect to login for embed routes — they handle session silently via apiKey+emailId
    if (window.location.pathname.startsWith("/vendorPortalEmbed")) return;
    toast.error(<CustomToast message={"Session expired. Please log in again"} />);
    // Delay the execution of clearing storage and redirection
    setTimeout(() => {
      localStorage.clear(); // Clear all local storage
      window.location.href = "/"; // Redirect to the home page
    }, 1000); // 1000ms = 1 seconds
  }
};

const App = () => {
  const [actor, setActor] = useState<FrontendActor>(() => {
    const localData = localStorage.getItem("actor");
    try {
      return localData ? JSON.parse(localData) : null;
    } catch (e) {
      return null;
    }
  });

  // Usetiful tags
  useEffect(() => {
    if (!actor) return; // Ensure actor is present before proceeding

    const script = document.createElement("script");
    script.nonce = "skip-5";
    script.innerHTML = `
      window.usetifulTags = {
        userId: ${actor.userId ? `"${actor.userId}"` : null},
        name: ${actor.userName ? `"${actor.userName}"` : null},
        ActorId: ${actor.id ? `"${actor.id}"` : null},
        ActorName: ${actor.actorName ? `"${actor.actorName}"` : null},
        ActorType: ${actor.actorType ? `"${actor.actorType}"` : null},
        ClientType: ${actor.clientType ? `"${actor.clientType}"` : null},
        ClientID: ${actor.clientId ? `"${actor.clientId}"` : null},
        AccountType: ${actor.accountType ? `"${actor.accountType}"` : null},
        UserType: ${actor.userType ? `"${actor.userType}"` : null},
        UserRole: ${actor.userRole ? `"${actor.userRole}"` : null},
        UserAgeInDays: ${actor.userAgeInDays ? `"${actor.userAgeInDays}"` : null},
        ActorAgeInDays: ${actor.actorAgeInDays ? `"${actor.actorAgeInDays}"` : null},
      };
    `;
    document.head.appendChild(script);

    return () => {
      document.head.removeChild(script); // Cleanup script on unmount
    };
  }, [actor]); // Re-run effect when `actor` changes

  useEffect(() => {
    // Function to fetch the backend version
    const fetchBackendVersion = () => {
      const localData = localStorage.getItem("actor");
      try {
        Axios.get("/api/version", {
          params: {
            userId: JSON.parse(localData)?.userId ? JSON.parse(localData)?.userId : null,
          },
        })
          .then((response) => {
            const backendVersion = response.data.version;
            // Access the version property from package.json
            const frontendVersion = packageJson.version;
            // Compare frontend and backend versions
            if (backendVersion && frontendVersion !== backendVersion) {
              // Perform a hard refresh
              // Reload the page only in production mode to ensure users have the latest version

              if (import.meta.env.PROD) {
                let refreshCount = parseInt(localStorage.getItem("refreshCount")) || 0;

                if (refreshCount < 3) {
                  refreshCount += 1;
                  localStorage.setItem("refreshCount", refreshCount.toString());
                  window.location.reload(); // Hard refresh
                } else {
                  localStorage.removeItem("refreshCount");
                  toast.error(
                    <CustomToast message="The application is updating to the latest version. Please wait a moment and refresh the page to access the latest features." />
                  );
                }
              }
            }
          })
          .catch((error) => {
            handleUnauthenticatedUser(error);
          });
      } catch (error) {
        console.log(error);
      }
    };

    // Polling interval (every 1 minutes in this example)
    const pollingInterval = 1 * 60 * 1000; // 1 minutes in milliseconds

    // Initial fetch
    fetchBackendVersion();

    // Set up interval for periodic polling
    const intervalId = setInterval(fetchBackendVersion, pollingInterval);

    // Cleanup function to clear the interval when the component unmounts
    return () => clearInterval(intervalId);
  }, []);

  const AdminRoute = ({ component: Component, ...rest }) => {
    return (
      <Route
        {...rest}
        render={(props) => {
          if (actor && actor.actorType === "Admin") {
            return <Component {...props} />;
          } else {
            return <Redirect to="/" />;
          }
        }}
      />
    );
  };

  useEffect(() => {
    const clarityProjectIDs = {
      production: "inqdavk56u",
      staging: "inqcy754wj",
      test: "inq7p42w47",
    };
    clarity.init(clarityProjectIDs[import.meta.env.VITE_APP_NAKAD_ENV]);
  }, []);

  const isDRdisableTab = (userRole: UserRole): boolean => {
    return !(userRole === UserRole.DRMaker || userRole === UserRole.DRChecker || userRole === UserRole.DRApprover);
  };

  const VendorPortalWrapper = () => {
    return (
      <VendorPortalLayout>
        <Switch>
          <Route exact path="/vendorPortal/invoice-rejection">
            <RejectedInvoicesVendorPortal />
          </Route>
          <Route exact path="/vendorPortal/reconciliation">
            <ReconciliationVendorPortal />
          </Route>
          <Route exact path="/vendorPortal/disputed-entries">
            <VpDisputedEntries isNonReconViewPage={false} />
          </Route>
          <Route exact path="/vendorPortal/raise-other-issues">
            <VpDisputedEntries isNonReconViewPage={true} />
          </Route>
          <Route exact path="/vendorPortal/ledger-summary">
            <LedgerSummaryVendorPortal />
          </Route>
          <Route exact path="/vendorPortal/hold-resolution">
            <HoldResolutionVendorPortal />
          </Route>
          <Route exact path="/vendorPortal/early-payment">
            <EarlyPaymentVendorPortal />
          </Route>
          <Route exact path="/vendorPortal/faq">
            <FaqVendorPortal />
          </Route>
          <Route
            exact
            path="/vendorPortal"
            render={({ location }) => {
              const searchParams = location.search; // Extract query parameters
              return <Redirect to={`/vendorPortal/ledger-summary${searchParams}`} />;
            }}
          />
        </Switch>
      </VendorPortalLayout>
    );
  };

  return (
    <BrowserRouter>
      <MixpanelPageTracker />
      <userContext.Provider value={{ actor, setActor }}>
        <SideBar />
        <Switch>
          <Route exact={true} path="/">
            <Login />
          </Route>
          <Route exact={true} path="/reset/:token/:accountType">
            <ChangePassword />
          </Route>
          <Route exact={true} path="/annotate">
            <AnnotationPage />
          </Route>
          <Route exact={true} path="/reset">
            <ResetPassword />
          </Route>
          <Route exact={true} path="/partnerPortal">
            <PartnerPortal />
          </Route>
          <Route exact={false} path="/balanceConfirmationPortal">
            <PartnerPortalWrapper />
          </Route>
          <Route exact={false} path="/balanceConfirmReport">
            <CommonReport useCaseType={UseCaseType.balanceConfirmationBeta} />
          </Route>
          <Route exact={false} path="/ledgerRequestReport">
            <CommonReport useCaseType={UseCaseType.ledgerRequestBeta} />
          </Route>
          <Route exact={true} path="/preprocessing/:scriptName">
            <LedgerPreprocessingPortal />
          </Route>

          <Route path="/vendorPortalEmbed">
            <VendorPortalLayout embedMode={true}>
              <Switch>
                <Route exact path="/vendorPortalEmbed/ledger-summary">
                  <LedgerSummaryVendorPortal />
                </Route>
                <Route
                  exact
                  path="/vendorPortalEmbed"
                  render={({ location }) => <Redirect to={`/vendorPortalEmbed/ledger-summary${location.search}`} />}
                />
              </Switch>
            </VendorPortalLayout>
          </Route>

          <Route path="/vendorPortal">
            <VendorPortalWrapper />
          </Route>
          <Route exact={true} path="/faq">
            <Faq />
          </Route>
          {/* Recon360 paths */}
          {import.meta.env.VITE_APP_NAKAD_ENV === "test" && isDRdisableTab(actor?.userRole) ? (
            <Route exact={true} path="/:actorName/recon360/:pathParam?/PaymentAdvice">
              <Recon360 subTab={RECON360_SUB_TAB.PAYMENT_ADVICE} />
            </Route>
          ) : null}
          {isDRdisableTab(actor?.userRole) && (
            <Route exact={true} path="/:actorName/recon360/:pathParam?/Ledger">
              <Recon360 subTab={RECON360_SUB_TAB.LEDGER} />
            </Route>
          )}
          {actor?.integration && isDRdisableTab(actor?.userRole) && (
            <Route exact={true} path="/:actorName/LedgerTools/LedgerDownload">
              <LedgerDownload />
            </Route>
          )}
          {actor?.integration && isDRdisableTab(actor?.userRole) && [3407255, 885953].includes(actor.id) && (
            <Route exact={true} path="/:actorName/LedgerTools/LedgerUpload">
              <LedgerUpload />
            </Route>
          )}
          {actor?.integration && [UserRole.ReconDRApprover, UserRole.DRApprover].includes(actor?.userRole) && (
            <Route exact={true} path="/:actorName/LedgerTools/VendorPaymentAutomation">
              <VendorPaymentAutomation />
            </Route>
          )}
          {import.meta.env.VITE_APP_NAKAD_ENV !== "production" && isDRdisableTab(actor?.userRole) ? (
            <Route exact={true} path="/:actorName/supplierchaindashboard">
              <SupplierChainDashboard />
            </Route>
          ) : null}
          {isDRdisableTab(actor?.userRole) && (
            <Route exact={true} path="/:actorName/reconSettings">
              <ReconSettings />
            </Route>
          )}
          {isDRdisableTab(actor?.userRole) && (
            <Route exact={true} path="/:actorName/taskBoard">
              <TaskTracker />
            </Route>
          )}

          {isDRdisableTab(actor?.userRole) && (
            <Route exact={true} path="/:actorName/partnerCommunication/msmeConfirmation">
              <PartnerCommunicationContext>
                <MsmeConfirmation />
              </PartnerCommunicationContext>
            </Route>
          )}
          {isDRdisableTab(actor?.userRole) && (
            <Route exact={true} path="/:actorName/partnerCommunication/balanceConfirmV2">
              <PartnerCommunicationContext>
                <BalanceConfirmationPortalContext>
                  <AuditCommunication />
                </BalanceConfirmationPortalContext>
              </PartnerCommunicationContext>
            </Route>
          )}
          {isDRdisableTab(actor?.userRole) && (
            <Route exact={true} path="/:actorName/partnerMaster">
              <PartnerMaster />
            </Route>
          )}
          {isDRdisableTab(actor?.userRole) && (
            <Route exact={true} path="/:actorName/disputeResolution/closureTracker">
              <PartnerCommunicationContext>
                <ClosureTracker />
              </PartnerCommunicationContext>
            </Route>
          )}
          {(!isDRdisableTab(actor?.userRole) || actor?.userRole === UserRole.ReconDRApprover) && (
            <Route exact={true} path="/:actorName/disputeResolution/rejectedInvoices">
              <RejectedInvoices />
            </Route>
          )}
          {(actor?.userRole === UserRole.DRMaker ||
            actor?.userRole === UserRole.DRChecker ||
            actor?.userRole === UserRole.DRApprover ||
            actor?.userRole === UserRole.ReconDRApprover) && (
            <Route exact={true} path="/:actorName/disputeResolution/disputedEntries">
              <DisputedEntries />
            </Route>
          )}
          {(actor?.userRole === UserRole.DRMaker ||
            actor?.userRole === UserRole.DRChecker ||
            actor?.userRole === UserRole.DRApprover ||
            actor?.userRole === UserRole.ReconDRApprover) && (
            <Route exact={true} path="/:actorName/disputeResolution/vendorHold">
              <VendorHold />
            </Route>
          )}
          {actor?.integration && canManageDrUserSettings(actor) && (
            <Route exact={true} path="/:actorName/disputeResolution/drUserSettings">
              <DrUserSettings />
            </Route>
          )}
          {isDRdisableTab(actor?.userRole) && (
            <Route exact={true} path="/:actorName/ReconMIS/partnerRiskManagement">
              <PartnerRiskManagement />
            </Route>
          )}
          {isDRdisableTab(actor?.userRole) && (
            <Route exact={true} path="/:actorName/ReconMIS/reportsMailAutomation">
              <MailMISReports />
            </Route>
          )}
          {/* AdminRoute for admin paths */}
          <AdminRoute exact={true} path="/admin/userlist" component={Userlist} />
          <AdminRoute exact={true} path="/admin/sapdata" component={SapData} />
          <AdminRoute exact={true} path="/admin/ledgerdata" component={LedgerData} />
          <AdminRoute exact={true} path="/admin/configtemplates" component={ConfigTemplates} />
          <AdminRoute exact={true} path="/admin/scripts" component={PreprocessingScripts} />
          <AdminRoute exact={true} path="/admin/tallyvoucher" component={TallyVoucher} />
          <AdminRoute exact={true} path="/admin/tallyledger" component={TallyLedger} />
          <AdminRoute exact={true} path="/admin/CBUpdate" component={CBUpdate} />
          <AdminRoute exact={true} path="/admin/UnpaidInvoice" component={UnpaidInvoice} />
          <AdminRoute exact={true} path="/admin/PaymentDetails" component={PaymentDetails} />
          <AdminRoute exact={true} path="/admin/Register" component={Register} />
          <AdminRoute exact={true} path="/admin/reconAnalytics" component={ReconAnalytics} />
          <AdminRoute
            exact={true}
            path="/admin/partnerCommunicationAnalytics"
            component={PartnerCommunicationAnalytics}
          />
          <AdminRoute exact={true} path="/admin/taskManagement" component={TaskManagementAnalytics} />
          <AdminRoute exact={true} path="/admin/consolidatedMIS" component={ConsolidatedMIS} />
          <Redirect to="/" />
        </Switch>
      </userContext.Provider>
      <ToastContainer autoClose={5000} icon={false} closeButton={false} draggable limit={6} stacked />
    </BrowserRouter>
  );
};

export default App;
